import { Link } from 'react-router-dom';
import Header from '../../components/feature/Header';

export default function HomePage() {
  return (
    <div className="min-h-screen bg-white">
      <Header />

      {/* Hero Section */}
          <section className="relative bg-cover bg-center min-h-[450px] flex items-center" style={{ backgroundImage: 'url(/images/CAAGS_01-on-field.jpg)'}}>
        <div className="absolute inset-0 bg-gradient-to-b from-black/40 via-black/30 to-black/40"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl text-white">
            <h1 className="text-5xl md:text-6xl font-bold mb-6 leading-tight">
              American-Made Attachments Built to Work as Hard as You Do
            </h1>
            <p className="text-xl mb-8 leading-relaxed">
              From tree pullers and grapples to rakes and stump buckets, AgriWorks delivers tough, dependable equipment trusted by farmers, landowners, and contractors across the country.
            </p>
            <div className="flex flex-wrap gap-4">
              
              <a href="tel:6812968160" className="bg-white text-[#c41e3a] px-8 py-3 rounded font-bold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
                Call Us Now
              </a>
              <Link to="/products" className="bg-transparent border-2 border-white text-white px-8 py-3 rounded font-bold hover:bg-white hover:text-[#c41e3a] transition-colors whitespace-nowrap cursor-pointer">
                Explore Our Products
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Why Deal With Equipment Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold mb-6 text-gray-900">
                Why Deal With Equipment That Just Can't Keep Up?
              </h2>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                If you've been around the industry for a while, you've seen it: attachments that look fine in the catalog but fall short in the field. Thin steel. Weak welds. Pins that shear. Paint that flakes before the season's even over. And the worst part? Trying to get service—if you can even get someone on the phone.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                Too often, landowners and professionals are stuck choosing between overpriced name brands or off-brand gear that won't last. Either way, you're wasting time, money, and energy on equipment that just can't keep up.
              </p>
            </div>
            <div className="rounded-lg overflow-hidden">
              <img 
                              src="/images/525_02.jpg" 
                alt="Equipment in action" 
                className="w-100 h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Every Job Takes Longer Section */}
      <section className="py-12 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-">
            <div className=" ">
              <img 
                              src="/images/ED6451-1.jpg" 
                alt="Heavy duty equipment" 
                className="w-90 h-full object-cover"
              />
            </div>
            <div>
              <h3 className="text-3xl font-bold mb-6 text-gray-900">
                And Every Job Seems to Take Longer Than It Should
              </h3>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                When your tools aren't reliable, every task becomes a headache. Clearing overgrowth turns into an all-day affair. Grapples that don't clamp right mean more trips. A stump bucket that bends under pressure is more than an inconvenience—it's downtime you didn't plan for.
              </p>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                The result? Delays, lost productivity, and a whole lot of frustration.
              </p>
              <p className="text-lg text-gray-700 mb-8 font-semibold">
                You work hard. Your equipment should too.
              </p>
              
              <h4 className="text-2xl font-bold mb-4 text-gray-900">
                Precision-Manufactured Attachments Get the Job Done
              </h4>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                At AgriWorks, we don't cut corners—we cut trees, haul debris, dig stumps, and move whatever's in your way. Every attachment we make is built to perform under pressure, day after day, year after year.
              </p>
              <p className="text-lg text-gray-700 mb-6 leading-relaxed">
                Our team designs tools based on real-world experience. Farmers, contractors, and property owners count on our gear because it holds up—no excuses.
              </p>
              <p className="text-lg text-gray-700 leading-relaxed">
                If you're tired of second-guessing your tools, you're in the right place.
              </p>
            </div>
          </div>
        </div>
      </section>

      {/* Our Products Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4 text-gray-900">Our Products</h2>
            <p className="text-2xl font-semibold mb-4 text-gray-800">Tackle Tough Jobs with the Right Tools</p>
            <p className="text-lg text-gray-700 max-w-4xl mx-auto">
              At AgriWorks, we don't build flashy toys—we engineer serious equipment for serious work. Whether you're clearing land, managing overgrowth, or moving heavy material, we've got a tool that's up to the task. Browse our core categories below to find what you need:
            </p>
          </div>

          <div className="mb-12">
            <img 
                          src="/images/AAGM_01.jpg" 
              alt="Product showcase" 
              className="w- max-w-2xl mx-auto rounded-lg shadow-lg"
            />
          </div>

          <div className="mb-12">
            <h3 className="text-2xl font-bold mb-4 text-gray-900">Tree & Brush Pullers</h3>
            <p className="text-lg text-gray-700 mb-8">Remove invasive trees and deep-rooted brush with ease. Built for durability and bite.</p>
            
            <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-8">
              <div className="bg-gray-50 p-6 rounded-lg">
                <h4 className="text-xl font-bold mb-3 text-gray-900">Grapples</h4>
                <p className="text-gray-700">Securely move logs, debris, or bales—designed for strength and control in every load.</p>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg">
                <h4 className="text-xl font-bold mb-3 text-gray-900">Rakes</h4>
                <p className="text-gray-700">Ideal for site cleanup, grading, and field prep. Heavy-duty tines, zero nonsense.</p>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg">
                <h4 className="text-xl font-bold mb-3 text-gray-900">Stump Buckets</h4>
                <p className="text-gray-700">Dig out stubborn stumps and rocks without breaking your back—or your machine.</p>
              </div>
              <div className="bg-gray-50 p-6 rounded-lg">
                <h4 className="text-xl font-bold mb-3 text-gray-900">Custom Attachments</h4>
                <p className="text-gray-700">Got a special job? We've got the experience to design and build the right tool.</p>
              </div>
            </div>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
            <div className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow cursor-pointer">
              <img 
                              src="/images/ED6451.jpg" 
                alt="Hyreach Clipper" 
                className="w-full h-48 object-cover"
              />
              <div className="p-4">
                <h4 className="text-lg font-bold text-gray-900">Hyreach Clipper</h4>
              </div>
            </div>
            <div className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow cursor-pointer">
              <img 
                              src="/images/527_Hero_02-1024x724.jpg" 
                alt="Tree Puller" 
                className="w-full h-48 object-cover"
              />
              <div className="p-4">
                <h4 className="text-lg font-bold text-gray-900">Tree Puller</h4>
              </div>
            </div>
            <div className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow cursor-pointer">
              <img 
                              src="/images/AAGD_01-1024x683.jpg" 
                alt="Add a Grapple" 
                className="w-full h-48 object-cover"
              />
              <div className="p-4">
                <h4 className="text-lg font-bold text-gray-900">Add a Grapple</h4>
              </div>
            </div>
            <div className="bg-white rounded-lg overflow-hidden shadow-lg hover:shadow-xl transition-shadow cursor-pointer">
              <img 
                              src="/images/327_BigMouth_01-1024x576.jpg" 
                alt="Grapple Rake" 
                className="w-full h-48 object-cover"
              />
              <div className="p-4">
                <h4 className="text-lg font-bold text-gray-900">Grapple Rake</h4>
              </div>
            </div>
          </div>

          
            
            
            
            
          

          <div className="text-center">
            <Link to="/products" className="inline-block bg-[#c41e3a] text-white px-8 py-3 rounded font-bold hover:bg-[#a01828] transition-colors whitespace-nowrap cursor-pointer">
              BROWSE ALL PRODUCTS
            </Link>
          </div>
        </div>
      </section>

      

      {/* What Makes Us Different Section */}
      <section className="py-20 bg-[#f5f5f5]">
        <div className="container mx-auto px-4">
          <div className="text-center mb-12">
            <h2 className="text-4xl font-bold mb-4 text-[#4a4a4a]">What Makes Our Attachments Different?</h2>
            <p className="text-base text-[#8b4513] mb-2">
              There are a lot of attachment manufacturers out there. So why do so many customers stick with AgriWorks after their first order?
            </p>
            <p className="text-base text-[#8b4513]">Here's what sets us apart:</p>
          </div>

          <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-8 mb-12">
            <div className="bg-white p-8 rounded-lg border border-gray-200">
              <div className="w-16 h-16 mb-4">
                <img 
                                  src="/images/5b0dcdd27.jpg" 
                  alt="Built for Real-World Stress" 
                  className="w-full h-full object-contain"
                />
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#4a4a4a]">Built for Real-World Stress</h3>
              <p className="text-[#8b4513] text-sm leading-relaxed">
                We don't design in a vacuum. Every tool we make is field-tested and engineered to hold up in the conditions you actually work in—mud, rocks, roots, and all.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg border border-gray-200">
              <div className="w-16 h-16 mb-4">
                <img 
                                  src="/images/334d91205a92.jpg" 
                  alt="Heavy-Gauge Steel" 
                  className="w-full h-full object-contain"
                />
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#4a4a4a]">Heavy-Gauge Steel Where It Counts</h3>
              <p className="text-[#8b4513] text-sm leading-relaxed">
                We're not using thin, decorative sheet metal to save on weight or cost. Our attachments use real steel and reinforced stress points so you can push your equipment without worrying about failure.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg border border-gray-200">
              <div className="w-16 h-16 mb-4">
                <img 
                                  src="/images/b011766bb.jpg" 
                  alt="Universal Compatibility" 
                  className="w-full h-full object-contain"
                />
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#4a4a4a]">Universal Compatibility</h3>
              <p className="text-[#8b4513] text-sm leading-relaxed">
                Our skid steer and tractor attachments are designed to work with common quick attach systems and major equipment brands, so you don't have to jump through hoops.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg border border-gray-200">
              <div className="w-16 h-16 mb-4">
                <img 
                                  src="/images/9899181.jpg" 
                  alt="Quality Welding" 
                  className="w-full h-full object-contain"
                />
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#4a4a4a]">Tight Tolerances and Quality Welding</h3>
              <p className="text-[#8b4513] text-sm leading-relaxed">
                You can see the difference. Clean welds, clean lines, and hardware that fits like it should—every time.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg border border-gray-200">
              <div className="w-16 h-16 mb-4">
                <img 
                                  src="/images/f4140581.jpg" 
                  alt="Made in USA" 
                  className="w-full h-full object-contain"
                />
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#4a4a4a]">Proudly Made in the USA</h3>
              <p className="text-[#8b4513] text-sm leading-relaxed">
                We manufacture everything right here in the heart of America. That means better control, better quality, and a team you can actually talk to when you need help.
              </p>
            </div>
            <div className="bg-white p-8 rounded-lg border border-gray-200">
              <div className="w-16 h-16 mb-4">
                <img 
                                  src="/images/ce059ca043.jpg" 
                  alt="Dealer-Friendly" 
                  className="w-full h-full object-contain"
                />
              </div>
              <h3 className="text-xl font-bold mb-3 text-[#4a4a4a]">Dealer-Friendly Design</h3>
              <p className="text-[#8b4513] text-sm leading-relaxed">
                Clear documentation, consistent availability, and straightforward support—dealers trust us because we make their lives easier, too.
              </p>
            </div>
          </div>

          <div className="text-center">
            <p className="text-base text-[#8b4513]">
              From the first weld to the final coat of paint, our goal is simple: deliver attachments that are tough, trustworthy, and ready to go to work.
            </p>
          </div>
        </div>
      </section>

      

      {/* Testimonials Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold mb-12 text-center text-gray-900">What Our Customers Are Saying</h2>
          
          <div className="max-w-4xl mx-auto">
            <div className="bg-gray-50 p-8 rounded-lg shadow-lg mb-8">
              <div className="flex items-start mb-4">
                <i className="ri-double-quotes-l text-4xl text-[#c41e3a] mr-4"></i>
                <div>
                  <p className="text-lg text-gray-700 mb-4">
                    I bought the Big Mouth Grapple for my John Deere 4 Series tractor. There were some fitment issues at first. The company did a great job of taking care of my concerns and making it right. The grapple looks and works great. Love the double jaw style and built very heavy. Highly recommend.
                  </p>
                  <p className="font-bold text-gray-900">- Scott H</p>
                </div>
              </div>
            </div>

            
            
          </div>
        </div>
      </section>

      {/* Why Choose Us Section */}
      <section className="py-20 bg-gray-50">
        <div className="container mx-auto px-4">
          <div className="grid md:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl font-bold mb-6 text-gray-900">Why Choose Us</h2>
              <p className="text-2xl font-semibold mb-6 text-gray-800">Built with Integrity. Backed by Experience.</p>
              <p className="text-lg text-gray-700 mb-6">
                AgriWorks has been designing and fabricating tractor and skid steer attachments since 2001. Our gear is built right here in the U.S.—by craftsmen who understand what it takes to keep a farm, a ranch, or a job site running smoothly.
              </p>
              <p className="text-lg text-gray-700 mb-6">
                We don't chase trends. We don't make shortcuts. Instead, we focus on what matters:
              </p>
              <ul className="space-y-3 mb-6">
                <li className="flex items-start">
                  <i className="ri-check-line text-[#c41e3a] text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">Quality steel, smart design, real-world testing</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-[#c41e3a] text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">Consistent fit and compatibility for major equipment brands</span>
                </li>
                <li className="flex items-start">
                  <i className="ri-check-line text-[#c41e3a] text-xl mr-3 mt-1"></i>
                  <span className="text-gray-700">Dealer and customer support that actually picks up the phone</span>
                </li>
              </ul>
              <p className="text-lg text-gray-700 mb-6">
                Our reputation was built the old-fashioned way—by delivering products that do what we say they'll do. And we don't take that lightly.
              </p>
              <p className="text-lg text-gray-700 mb-8">
                Whether you're a longtime customer or just discovering our brand, we're here to make your workday easier, your gear more capable, and your operation more productive.
              </p>
             
            </div>
            <div className="  ">
              <img 
                              src="/images/PFAAGA_01.jpg" 
                alt="Quality manufacturing" 
                className="w-100 h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      

      

      {/* FAQ Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <h2 className="text-4xl font-bold mb-12 text-center text-gray-900">Frequently Asked Questions</h2>
          
          <div className="max-w-4xl mx-auto space-y-6">
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3 text-gray-900">1. What equipment do your attachments work with?</h3>
              <p className="text-gray-700">
                Most of our attachments are designed for universal compatibility with skid steers and compact tractors using common quick-attach systems. If you have a specific machine, feel free to reach out and we'll confirm fitment.
              </p>
            </div>
            
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3 text-gray-900">2. Are your attachments made in the USA?</h3>
              <p className="text-gray-700">
                Yes, every AgriWorks attachment is built right here in the United States. We use high-quality steel and fabricate our products in-house to maintain strict quality control.
              </p>
            </div>
            
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3 text-gray-900">3. Do you sell directly to customers, or just through dealers?</h3>
              <p className="text-gray-700">
                We primarily work through our network of authorized dealers, but we're always happy to answer product questions directly. Use our <a href="https://agriworks.com/find-a-dealer/" target="_blank" rel="noopener noreferrer" className="text-[#c41e3a] font-bold hover:underline">Find a Dealer</a> tool to get started.
              </p>
            </div>
            
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3 text-gray-900">4. Can I get a custom-built attachment?</h3>
              <p className="text-gray-700">
                Yes. If you have a specific application that requires something custom, get in touch. Our team has designed and built specialty attachments for everything from utility crews to unique agricultural operations.
              </p>
            </div>
            
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3 text-gray-900">5. What's your warranty policy?</h3>
              <p className="text-gray-700">
                Our attachments come with a limited manufacturer's warranty that covers defects in materials and workmanship. Contact your dealer or our support team for specific warranty details.
              </p>
            </div>
            
            <div className="bg-gray-50 p-6 rounded-lg">
              <h3 className="text-xl font-bold mb-3 text-gray-900">6. How do I become a dealer?</h3>
              <p className="text-gray-700">
                We're always looking to partner with reputable equipment dealers across the country. If you're interested in offering AgriWorks products to your customers, reach out via our <Link to="/contact" className="text-[#c41e3a] font-bold hover:underline">Contact Us</Link> page and let's talk.
              </p>
            </div>
          </div>

          <div className="text-center mt-12">
                      <Link to="/help-faqs" className="inline-block bg-[#c41e3a] text-white px-8 py-3 rounded font-bold hover:bg-[#a01828] transition-colors whitespace-nowrap cursor-pointer">
              READ MORE FAQs
            </Link>
          </div>
        </div>
      </section>

      {/* Final CTA Section */}
      <section 
        className="py-20 bg-cover bg-center relative"
              style={{ backgroundImage: 'url(/images/CAAGS_01-on-field.jpg)'}}
      >
        <div className="absolute inset-0 bg-black/50"></div>
        <div className="container mx-auto px-4 relative z-10">
          <h2 className="text-4xl font-bold mb-6 text-white">Let's Get to Work</h2>
          <p className="text-xl text-white mb-8 max-w-3xl mx-auto">
            Whether you need one attachment or a whole lineup, we're ready to help. Call us with questions, browse our product catalog, or find a dealer near you to get started today.
          </p>
          <div className="flex flex-wrap justify-center gap-4">
            
            <a href="tel:6812968160" className="bg-white text-[#c41e3a] px-8 py-3 rounded font-bold hover:bg-gray-100 transition-colors whitespace-nowrap cursor-pointer">
              Call Us Now
            </a>
            <Link to="/products" className="bg-transparent border-2 border-white text-white px-8 py-3 rounded font-bold hover:bg-white hover:text-[#c41e3a] transition-colors whitespace-nowrap cursor-pointer">
              Browse Products
            </Link>
          </div>
        </div>
      </section>

      {/* Footer */}
      <footer 
        className="bg-cover bg-center relative py-16"
              style={{ backgroundImage: 'url(/images/scaled.jpg)'}}
      >
        <div className="absolute inset-0 bg-[#1a1a1a]/90"></div>
        <div className="container mx-auto px-4 relative z-10">
          <div className="grid md:grid-cols-2 lg:grid-cols-4 gap-8 text-white">
            <div>
              <img 
                              src="/images/lagoos.png" 
                alt="AgriWorks Logo" 
                className="h-24 mb-4"
              />
              <h6 className="text-sm mb-4">
                Powered by AgriWorks<br />
               
                <a href="tel:6812968160" className="hover:underline">(681) 296-8160</a>
              </h6>
              <div>
                
                
              </div>
            </div>

            <div>
              <h3 className="font-bold mb-4 text-lg">Contact</h3>
              <ul className="space-y-2 text-sm">
                <li>
                  <a href="mailto:jolyn.consult@hotmail.com" className="hover:underline">Email: jolyn.consult@hotmail.com</a>
                </li>
                <li>
                  <a href="tel:6812968160" className="hover:underline">Phone: (681) 296-8160</a>
                </li>
                <li>23 Margaret Dr, Somerset, NJ 08873</li>
              </ul>
            </div>

            <div>
              <h3 className="font-bold mb-4 text-lg">Links</h3>
              <ul className="space-y-2 text-sm">
                <li>
                  <Link to="/products" className="hover:underline">Products</Link>
                </li>
                <li>
                  
                </li>
                <li>
                  <Link to="/contact" className="hover:underline">Contact Us</Link>
                </li>
                <li>
                 
                </li>
              </ul>
            </div>

            <div>
              <img 
                              src="/images/made-in-the-usa.webp" 
                alt="Made in USA" 
                className="w-48 mb-4"
              />
            </div>
          </div>

          <div className="mt-12 pt-8 border-t border-white/20 text-center text-sm text-white/80">
                      <p>© {new Date().getFullYear()} AgriWorks Manufacturing LLC. All rights reserved. </p>
          </div>
        </div>
      </footer>
    </div>
  );
}
